import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus, faSignOutAlt, faUserEdit } from "@fortawesome/free-solid-svg-icons";
import { faEdit, faTrashAlt } from "@fortawesome/free-regular-svg-icons";
import { useNavigate } from "react-router-dom";

import { SiteHeader } from "../../components/header/header";
import { SiteFooter } from "../../components/footer/footer";
import { UseAuthentication } from "../../services/authentication/authentication.context";



export const AdminDashboard = () => {

    const { userAccount } = UseAuthentication();

    const  navigateTo  = useNavigate();

    return (
        <div className="f-pg app-pg">
            <SiteHeader />
            <div className="admin-data-pane">
                <div className="admin-data-unit flx-rw">
                    <div className="data-image flx-cnt">
                        {userAccount?.avatar ?
                            <img src={userAccount?.avatar} alt="" /> :
                            <span>{userAccount?.names[0]}</span>
                        }
                    </div>
                    <span className="data-info">{userAccount?.names}</span>
                </div>
            </div>
            <div className="admin-dashboard">
                <div className="dash-stats">
                    <div className="hd md-txt">Cars</div>
                    <div className="hd">
                        <span>Total:{" "}</span>
                        <span>{0}</span>
                    </div>
                </div>
                <div className="dash-buttons">
                    <button className="dash-button" onClick={() => navigateTo("/addcar")}>
                        <FontAwesomeIcon icon={faPlus} />
                        <span className="d-b-txt">Add Car</span>
                    </button>
                    <button 
                        className="dash-button"
                        onClick={() => navigateTo(`/update_delete`)}
                    >
                        <FontAwesomeIcon icon={faEdit} />
                        <span className="d-b-txt">Update/Delete</span>
                    </button>
                    <button className="dash-button">
                        <FontAwesomeIcon icon={faUserEdit} />
                        <span className="d-b-txt">Update account</span>
                    </button>
                    <button className="dash-button">
                        <FontAwesomeIcon icon={faSignOutAlt} />
                        <span className="d-b-txt">Sign out</span>
                    </button>
                    <button className="dash-button">
                        <FontAwesomeIcon icon={faTrashAlt} />
                        <span className="d-b-txt">Close Acount</span>
                    </button>
                </div>
            </div>
            <SiteFooter />
        </div>
    )
}